/**
 * Labstep
 *
 * @module screens/Organization/FreeTrialEnded
 * @desc Free Trial Ended screen
 */

import { FullScreenPage as LayoutFullScreenPage } from 'labstep-web/components/Layout/FullScreenPage';
import { OrganizationPlanActionUpgradeContainer as OrganizationPlanActionUpgrade } from 'labstep-web/components/OrganizationPlan/Action/Upgrade';
import { Header } from 'labstep-web/core/Header';
import { MailTag } from 'labstep-web/core/MailTag';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IScreensOrganizationFreeTrialEndedProps } from './types';

export const ScreensOrganizationFreeTrialEnded: React.FC<
  IScreensOrganizationFreeTrialEndedProps
> = ({ userOrganization }) => (
  <LayoutFullScreenPage>
    <div className={styles.center}>
      <Image centered src="/img/error/locked.svg" size="large" />
      <Header>Your trial of Labstep has ended</Header>
      {userOrganization.type === 'admin' ? (
        <>
          <p>
            To regain access to your workspaces click &apos;Upgrade
            Now&apos; or contact <MailTag department="info" />
          </p>
          <OrganizationPlanActionUpgrade
            organization={userOrganization.organization}
          />
        </>
      ) : (
        <p>
          Please contact your organization&apos;s admin to upgrade
        </p>
      )}
    </div>
  </LayoutFullScreenPage>
);
